import { useCallback } from "react";
import { TrackingObject } from "@features/analytics/utils/types";

const useSendDataToGTM = () => {
  const sendDataToGTM = useCallback((data: TrackingObject) => {
    if (typeof window === "undefined") return;
    if (window.dataLayer === undefined) return;
    window.dataLayer.push(data);
  }, []);

  return sendDataToGTM;
};

export default useSendDataToGTM;
